import PropTypes from 'prop-types';

export default function Link({ classes = [], blank = false, href = '', onClick = () => {}, small = false, testId = '', children }) {
	const classNames = ['link', ...classes];
	if (small) classNames.push('link--small');

	const props = {};

	if (testId) {
		props['data-testid'] = testId;
	}

	if (!href) {
		return (
			<button onClick={onClick} className={classNames.join(' ')} {...props}>
				{children}
			</button>
		);
	}

	props.href = href;
	props.target = blank ? '_blank' : '_self';
	if (blank) {
		props.rel = 'noopener noreferrer';
	}

	return (
		<a onClick={onClick} className={classNames.join(' ')} {...props}>
			{children}
		</a>
	);
}

Link.propTypes = {
	blank: PropTypes.bool,
	children: PropTypes.node,
	classes: PropTypes.array,
	href: PropTypes.string,
	onClick: PropTypes.func,
	small: PropTypes.bool,
	testId: PropTypes.string,
};
